module.exports = {
  loginComponent: {
    login: "login",
    logout : "logout"
  },
};



// WEBPACK FOOTER //
// ./src/language/en.js